import { queryOptions } from '@tanstack/react-query'

import { getSubscriptions } from './subscriptions.service'

export const entitySubscriptionsQueryOptions = (entityId: string) =>
  queryOptions({
    queryKey: ['subscriptions', entityId],
    queryFn: async () => getSubscriptions(entityId),
  })
